import { message, Space, notification, Select, Popconfirm } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ModalItem,
  ButtonItem,
  Form,
  FormItem,
  InputItem,
  SelectItem,
  ErrorItem,
} from "../../../../Components/Items";
import ModalAcuseCancelacionNota from "../ModalAcuseCancelacionNota/ModalAcuseCancelacionNota";

const { Option } = Select;

class CancelarNotaDeCreditoVenta extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    complemento: false,
    pagarVenta: false,
    modalAcuseVisible: false,
    acuseNotaId: null,
  };
  onFinishFailed(e) {
    ErrorItem(e);
  }
  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "notasDeCreditoVenta/datosNota",
        { notaId: this.props.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.satatus === 404) return;
        this.setState({ pagarVenta: res.data.pagarVenta });
      });
    this.setState({ loading: false });
  }
  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "notasDeCreditoVenta/cancelarNotaDeCredito",
        { ...values, notaId: this.props.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Nota de credito cancelada");
          this.formRef.current.resetFields();
          // Igual que CancelarVenta: se abre el acuse encima y al cerrarlo se cierran los dos.
          this.mostrarModalAcuse();
        } else if (res.data.success === 1) {
          notification.error({
            message: "Error",
            description: res.data.message,
            duration: null,
          });
        } else {
          message.error("Sucedio un error y no se pudo cancelar");
        }
        this.setState({ loading: false });
      });
  }
  cerrarCancelarNotaDeCreditoVenta() {
    this.props.cerrarCancelarNotaDeCreditoVenta();
  }
  mostrarModalAcuse() {
    this.setState({ modalAcuseVisible: true, acuseNotaId: this.props.id });
  }
  cerrarModalAcuse = () => {
    this.setState({ modalAcuseVisible: false, acuseNotaId: null });
    this.props.cerrarCancelarNotaDeCreditoVenta();
  };
  render() {
    return (
      <>
      <ModalItem
        title="Cancelar Nota De Credito Venta"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarCancelarNotaDeCreditoVenta.bind(this)}
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="cancelarNotaDeCreditoVenta"
          layout
          width={700}
          onCancel={this.cerrarCancelarNotaDeCreditoVenta.bind(this)}
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormItem
            label="Motivo"
            name="motivo"
            required
            pattern
            margin
            max={200}
          >
            <SelectItem placeholder="Motivo">
              <Option value="01">
                01 - Comprobante emitido con errores con relación.
              </Option>
              <Option value="02">
                02 - Comprobante emitido con errores sin relación.
              </Option>
              <Option value="03">03 - No se llevó a cabo la operación.</Option>
              <Option value="04">
                04 - Operación nominativa relacionada en una factura global.
              </Option>
            </SelectItem>
          </FormItem>
          <FormItem
            label="Folio Sustitucion"
            name="folioSustitucion"
            pattern
            margin
            max={200}
          >
            <InputItem placeholder="Folio de Sustitucion" />
          </FormItem>
          <p style={{textAlign: 'center', marginBottom: 10, paddingBottom: 10, marginTop: 10}}>
            {this.state.pagarVenta && "Se cancelara el pago a 1 venta"}
          </p>
          <p style={{textAlign: 'center', marginBottom: 0, paddingBottom: 0}}>
            {this.state.complemento
              ? "Se cancelara un complemento de pago."
              : ""}
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              marginTop: 20,
              marginBottom: 10,
            }}
          >
            <Space>
              <Popconfirm
                title={
                  "Se cancelara la nota de  credito"
                }
                onConfirm={() => this.formRef.current.formRef.current.submit()}
                okText="Ok"
                cancelText="Cancelar"
              >
                <ButtonItem
                  type="primary"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Cancelar Nota
                </ButtonItem>
              </Popconfirm>
              <ButtonItem
                type="primary"
                danger
                onClick={this.cerrarCancelarNotaDeCreditoVenta.bind(this)}
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Regresar
              </ButtonItem>
            </Space>
          </div>
        </Form>
      </ModalItem>
      <ModalAcuseCancelacionNota
        visible={this.state.modalAcuseVisible}
        notaId={this.state.acuseNotaId}
        cerrarModalPdf={this.cerrarModalAcuse}
      />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(CancelarNotaDeCreditoVenta);
